import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import * as serviceWorker from './serviceWorker';
import theme from "./Theme";
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store/Store';
import {CookiesProvider} from "react-cookie";

ReactDOM.render(
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CookiesProvider>
            <Router>
                <App />
            </Router>
          </CookiesProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
